export const REDUCER_NAME = '@messages'

export const ACTION_TYPES = {
  CAPTURE_MESSAGES: `${REDUCER_NAME}/CAPTURE_MESSAGES`,
  CLOSE: `${REDUCER_NAME}/CLOSE`,
}
